import React from 'react';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import Media from 'react-media';
import { Icon, Skeleton, Spin } from 'antd';
import { MEDIA_QUERY } from 'common/enum';
import SiderLayout from 'layouts/SiderLayout';

import { setToken } from 'services/axios';
import {
  setDataToLocalStorage,
  getDataFromLocalStorage,
} from 'services/local-storage';
import { StorageType } from 'common/enum';
//Redux store
import { getAuth } from 'store/auth/selector';
import {
  loadTermWordingAction,
  loadPrivacyWordingAction,
} from 'store/util/action';
import { checkLocalAuth } from 'store/auth/action';
import SiderMenuProvider from 'context/SiderMenu/SiderMenuProvider';
import { mobClientId } from 'services/axios';
import { routes } from 'common/enum';
const Login = React.lazy(() => import('../Login'));

class Routing extends React.Component {
  state = {
    appLoading: false,
  };
  componentDidMount() {
    const {
      checkLocalAuth,
      privacyWording,
      termWording,
      loadPrivacyWording,
      loadTermWording,
      router,
    } = this.props;
    checkLocalAuth();
    const queryString = router.location.search;
    const pathName = router.location.pathname;
    const searchParams = new URLSearchParams(queryString);

    window.addEventListener('storage', function(e) {
      const authInfo = getDataFromLocalStorage(StorageType.AuthInfo);
      if (!authInfo) {
        if (
          pathName.indexOf('onsite-booking') === -1 ||
          !searchParams.has('accessToken')
        ) {
          window.location.reload();
        }
      }
    });

    if (!termWording) {
      loadTermWording({
        filter: {
          key: `file/public/clients/${mobClientId}/terms`,
        },
      });
    }
    if (!privacyWording) {
      loadPrivacyWording({
        filter: {
          key: `file/public/clients/${mobClientId}/policy`,
        },
      });
    }
  }

  renderRouteComponent = (Component, Layout) => props => {
    return <Component {...props} />;
  };

  _isValidParams = async queryString => {
    const searchParams = new URLSearchParams(queryString);

    if (searchParams.has('organisationId') && searchParams.has('accessToken')) {
      const token = searchParams.get('accessToken');
      const organisationId = searchParams.get('organisationId');
      const date = searchParams.get('date');
      const endDate = searchParams.get('endDate');
      const time = searchParams.get('time');
      const poId = searchParams.get('poId');
      const companySiteId = searchParams.get('companySiteId');
      const serviceId = searchParams.get('serviceId');
      //this._checkValidPOToken(organisationId, organisationId);
      setToken(token);
      setDataToLocalStorage(StorageType.AuthInfo, null);
      setDataToLocalStorage(StorageType.OnsiteBookingInfo, {
        token,
        organisationId,
        companySiteId,
        date,
        endDate,
        time,
        poId,
        serviceId,
      });
      return true;
    }
    return false;
  };

  renderRoutes(routesData, isPublic) {
    return routesData.map(route => {
      return (
        <Route
          exact={route.exact ? true : false}
          key={route.path}
          path={route.path}
          render={this.renderRouteComponent(route.component, route.layout)}
        />
      );
    });
  }

  render() {
    const { auth, router } = this.props;
    let publicRoutes = [];
    const pathName = router.location.pathname;
    const queryString = router.location.search;
    publicRoutes = routes.filter(route => route.isPublic);
    if (
      publicRoutes.some(
        item =>
          pathName.indexOf(item.path) !== -1 &&
          this._isValidParams(queryString),
      )
    ) {
      return (
        <React.Suspense fallback={<Spin loading="true" />}>
          <Switch>{this.renderRoutes(publicRoutes)}</Switch>
        </React.Suspense>
      );
    }
    if (!auth || !auth.token) {
      return (
        <React.Suspense fallback={<Skeleton />}>
          <Switch>
            <Route
              path="/"
              name="Login"
              component={props => <Login {...props} />}
            />
          </Switch>
        </React.Suspense>
      );
    }
    return (
      <Media query={`(max-width: ${MEDIA_QUERY.MAX_WIDTH})`}>
        {isMobile => (
          <SiderMenuProvider isMobile={isMobile}>
            <SiderLayout {...this.props} isMobile={isMobile} navTheme="light">
              <React.Suspense fallback={<Icon type="loading" />}>
                <Switch>{this.renderRoutes(routes)}</Switch>
              </React.Suspense>
            </SiderLayout>
          </SiderMenuProvider>
        )}
      </Media>
    );
  }
}

const mapStateToProps = state => ({
  router: state.router,
  auth: getAuth(state),
});

const mapDispatchToProps = {
  checkLocalAuth: checkLocalAuth,
  loadTermWording: loadTermWordingAction,
  loadPrivacyWording: loadPrivacyWordingAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Routing);
